import axios from 'axios';

export function getHostAgreement(version) {
    const path = version
        ? `/legal/host-agreement/${encodeURIComponent(version)}`
        : '/legal/host-agreement';
    return axios.get(`${process.env.REACT_APP_API_URL}${path}`);
}
